import * as z from "zod";

export const updateOrderTrackingOrderViewFolder = {
  name: "updateOrderTrackingOrderViewFolder" as const,
  input: z.object({ folderId: z.string(), name: z.string() }),
  output: z.object({}),
};
